import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, TrendingDown, Minus, ExternalLink, ShoppingBag } from 'lucide-react';
export function Competitors() {
  const competitors = [{
    id: 1,
    name: 'Magazine Luiza',
    products: 1240,
    avgDiff: -2.5,
    trend: 'aggressive',
    color: 'bg-blue-600'
  }, {
    id: 2,
    name: 'Casas Bahia',
    products: 980,
    avgDiff: 1.2,
    trend: 'stable',
    color: 'bg-red-600'
  }, {
    id: 3,
    name: 'Amazon BR',
    products: 3500,
    avgDiff: -5.8,
    trend: 'aggressive',
    color: 'bg-yellow-500'
  }, {
    id: 4,
    name: 'Americanas',
    products: 1100,
    avgDiff: 0.5,
    trend: 'passive',
    color: 'bg-red-500'
  }, {
    id: 5,
    name: 'Mercado Livre',
    products: 5600,
    avgDiff: -1.2,
    trend: 'stable',
    color: 'bg-yellow-400'
  }, {
    id: 6,
    name: 'Carrefour',
    products: 850,
    avgDiff: 3.4,
    trend: 'passive',
    color: 'bg-blue-800'
  }, {
    id: 7,
    name: 'Fast Shop',
    products: 420,
    avgDiff: 8.5,
    trend: 'passive',
    color: 'bg-red-700'
  }, {
    id: 8,
    name: 'Kabum',
    products: 650,
    avgDiff: -4.2,
    trend: 'aggressive',
    color: 'bg-orange-500'
  }];
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.3
  }} className="space-y-6" data-id="element-390">
      <div className="flex justify-between items-center" data-id="element-391">
        <div data-id="element-392">
          <h1 className="text-2xl font-bold text-navy-900" data-id="element-393">
            Concorrentes Monitorados
          </h1>
          <p className="text-slate-500 mt-1" data-id="element-394">
            Visão geral da estratégia de preços do mercado
          </p>
        </div>
        <button className="bg-navy-900 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-navy-800 transition-colors" data-id="element-395">
          Adicionar Concorrente
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-396">
        {competitors.map((comp, index) => <motion.div key={comp.id} initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: index * 0.05
      }} className="bg-white rounded-xl shadow-sm border border-slate-100 overflow-hidden hover:shadow-md transition-shadow" data-id="element-397">
            <div className="p-6" data-id="element-398">
              <div className="flex items-center justify-between mb-6" data-id="element-399">
                <div className="flex items-center space-x-4" data-id="element-400">
                  <div className={`h-12 w-12 rounded-lg ${comp.color} flex items-center justify-center text-white font-bold text-xl`} data-id="element-401">
                    {comp.name.charAt(0)}
                  </div>
                  <div data-id="element-402">
                    <h3 className="font-bold text-lg text-navy-900" data-id="element-403">
                      {comp.name}
                    </h3>
                    <div className="flex items-center text-xs text-slate-500 mt-1" data-id="element-404">
                      <ShoppingBag className="h-3 w-3 mr-1" data-id="element-405" />
                      {comp.products.toLocaleString()} produtos
                    </div>
                  </div>
                </div>
                <button className="text-slate-400 hover:text-navy-900" data-id="element-406">
                  <ExternalLink className="h-5 w-5" data-id="element-407" />
                </button>
              </div>

              <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-408">
                <div className="bg-slate-50 p-3 rounded-lg" data-id="element-409">
                  <p className="text-xs text-slate-500 mb-1" data-id="element-410">Diferença Média</p>
                  <p className={`text-lg font-bold ${comp.avgDiff < 0 ? 'text-red-600' : 'text-emerald-600'}`} data-id="element-411">
                    {comp.avgDiff > 0 ? '+' : ''}
                    {comp.avgDiff}%
                  </p>
                </div>
                <div className="bg-slate-50 p-3 rounded-lg" data-id="element-412">
                  <p className="text-xs text-slate-500 mb-1" data-id="element-413">Agressividade</p>
                  <div className="flex items-center" data-id="element-414">
                    {comp.trend === 'aggressive' && <TrendingUp className="h-5 w-5 text-red-500 mr-2" data-id="element-415" />}
                    {comp.trend === 'stable' && <Minus className="h-5 w-5 text-amber-500 mr-2" data-id="element-416" />}
                    {comp.trend === 'passive' && <TrendingDown className="h-5 w-5 text-emerald-500 mr-2" data-id="element-417" />}
                    <span className="text-sm font-medium text-navy-900 capitalize" data-id="element-418">
                      {comp.trend === 'aggressive' ? 'Alta' : comp.trend === 'stable' ? 'Média' : 'Baixa'}
                    </span>
                  </div>
                </div>
              </div>

              <div className="w-full bg-slate-100 rounded-full h-2 mb-2" data-id="element-419">
                <div className={`h-2 rounded-full ${comp.trend === 'aggressive' ? 'bg-red-500' : comp.trend === 'stable' ? 'bg-amber-500' : 'bg-emerald-500'}`} style={{
              width: comp.trend === 'aggressive' ? '85%' : comp.trend === 'stable' ? '50%' : '25%'
            }} data-id="element-420"></div>
              </div>
              <p className="text-xs text-slate-400 text-right" data-id="element-421">
                Índice de competitividade
              </p>
            </div>
          </motion.div>)}
      </div>
    </motion.div>;
}